var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeaBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Idea",
    clipPath: "url(#clip0_312_682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.10576 3.36238L6.10575 3.36238C4.77427 3.67283 3.70272 4.7284 3.37537 6.05226C3.0474 7.37876 3.42275 8.73202 4.38036 9.67109C4.7032 9.98772 4.89904 10.4992 4.89904 11.0404V11.1286C4.89904 11.4989 5.05722 11.8329 5.30919 12.0668V12.7692C5.30919 13.4753 5.88357 14.0497 6.58966 14.0497H7.40997C8.11607 14.0497 8.69044 13.4753 8.69044 12.7692V12.0668C8.94241 11.8329 9.1006 11.4989 9.1006 11.1286V11.0388C9.1006 10.507 9.30643 9.98495 9.64826 9.6424L9.61287 9.60709L9.64826 9.6424C10.353 8.93612 10.7412 7.99742 10.7412 6.99967C10.7412 4.61393 8.53023 2.79727 6.10576 3.36238ZM6.31472 4.25867L6.31473 4.25867C8.16089 3.82818 9.82091 5.20584 9.82091 6.99967C9.82091 7.75216 9.52828 8.45967 8.99678 8.99233C8.47718 9.51304 8.18029 10.2591 8.18029 11.0388V11.1286C8.18029 11.3271 8.01868 11.4887 7.82013 11.4887H6.17951C5.98096 11.4887 5.81935 11.3271 5.81935 11.1286V11.0404C5.81935 10.2496 5.53098 9.51048 5.0247 9.01401C4.30245 8.30573 4.01945 7.28159 4.26876 6.27317C4.51373 5.28232 5.317 4.49127 6.31472 4.25867ZM7.77013 12.7692C7.77013 12.9677 7.60852 13.1294 7.40997 13.1294H6.58966C6.39112 13.1294 6.22951 12.9677 6.22951 12.7692V12.409H7.77013V12.7692Z",
    fill: "#8477AF",
    stroke: "#8477AF",
    strokeWidth: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.034 2.685L2.034 2.685C1.85429 2.50529 1.85429 2.21395 2.034 2.03424C2.2137 1.85454 2.50507 1.85453 2.68475 2.03425M2.034 2.685L3.84487 3.84508C4.02457 3.66537 4.02457 3.37403 3.84486 3.19433L2.68475 2.03425M2.034 2.685L3.19411 3.84508C3.19411 3.84508 3.19411 3.84508 3.19411 3.84508C3.37379 4.02479 3.66519 4.02479 3.84487 3.84508L2.034 2.685ZM2.68475 2.03425L2.64942 2.06958L2.68475 2.03424L2.68475 2.03425Z",
    fill: "#8477AF",
    stroke: "#8477AF",
    strokeWidth: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.07812 6.53984H0.410156C0.156026 6.53984 -0.05 6.74587 -0.05 7C-0.05 7.25413 0.156026 7.46016 0.410156 7.46016H2.07812C2.33225 7.46016 2.53828 7.25413 2.53828 7C2.53828 6.74587 2.33225 6.53984 2.07812 6.53984Z",
    fill: "#8477AF",
    stroke: "#8477AF",
    strokeWidth: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.5898 6.53984H11.9219C11.6677 6.53984 11.4617 6.74587 11.4617 7C11.4617 7.25413 11.6677 7.46016 11.9219 7.46016H13.5898C13.844 7.46016 14.05 7.25413 14.05 7C14.05 6.74587 13.844 6.53984 13.5898 6.53984Z",
    fill: "#8477AF",
    stroke: "#8477AF",
    strokeWidth: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.3152 2.03424L11.3152 2.03424C11.4949 1.85454 11.7863 1.85453 11.966 2.03425M11.3152 2.03424L10.8058 3.84508L11.966 2.685L11.9306 2.64964L11.966 2.685C12.1457 2.50532 12.1457 2.21395 11.966 2.03425M11.3152 2.03424L10.1551 3.19433C10.1551 3.19433 10.1551 3.19433 10.1551 3.19433C9.97538 3.37401 9.97539 3.66538 10.1551 3.84508L11.3152 2.03424ZM11.966 2.03425L11.9306 2.06959L11.966 2.03424C11.966 2.03424 11.966 2.03425 11.966 2.03425Z",
    fill: "#8477AF",
    stroke: "#8477AF",
    strokeWidth: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M7 -0.05C6.74587 -0.05 6.53984 0.156026 6.53984 0.410156V2.07812C6.53984 2.33225 6.74587 2.53828 7 2.53828C7.25413 2.53828 7.46016 2.33225 7.46016 2.07812V0.410156C7.46016 0.156026 7.25413 -0.05 7 -0.05Z",
    fill: "#8477AF",
    stroke: "#8477AF",
    strokeWidth: 0.1
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_312_682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaBlank);
export default __webpack_public_path__ + "static/media/idea-blank.b5485754c3d936c8d13366a5e03296de.svg";
export { ForwardRef as ReactComponent };